import './Content.css';
function Content({content,content_name}) {
  return (
      <div className="content-wrapper">
        {content}
      </div>
  );
}

export default Content;
